import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";
import ScheduleCheckinUniqueNumberModel from '../../../models/ScheduleCheckinUniqueNumberModel';

export default async function getScheduleCheckinUniqueNumbers(
  eventId = '',
  scheduleId = '',
  limit = 10,
  offset = 0,
  serialNumber = '',
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/scheduleCheckinUniqueNumber/getScheduleCheckinUniqueNumbers?eventId=${eventId}&scheduleId=${scheduleId}&limit=${limit}&offset=${offset}`
        + (serialNumber ? `&serialNumber=${serialNumber}` : ''),
      headers: {
        "Content-Type": "application/json",
      },
    };

    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = {
      data: [],
      count: _ret.data.data.count,
    };
    for (let i = 0; i < _ret.data.data.data.length; i++) {
      _return.data.push(ScheduleCheckinUniqueNumberModel(_ret.data.data.data[i]));
    }

    return _return;
  } catch (error) {
    console.log('Error getScheduleCheckinUniqueNumbers', error);
    throw error;
  }
}
